import React, { useEffect, useState, useRef } from 'react';
import '../../css/Components/Footer/Footer.css';
import { Link as Anchor } from 'react-router-dom';
import logo from '../../images/logo_principal.png'
import { baseURL } from '../../Components/url.js';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser } from '@fortawesome/free-solid-svg-icons';
import { faFacebookF, faTiktok, faYoutube, faInstagram, faXTwitter, faWikipediaW } from '@fortawesome/free-brands-svg-icons'
export default function Footer({ info }) {
    const [categorias, setCategorias] = useState([]);
    const [contactos, setContacto] = useState({});
    useEffect(() => {
        //cargarProductos();//cctm
    }, []);

    useEffect(() => {
        cargarContacto();
    }, [info]);


    const cargarContacto = () => { setContacto(info) };
    const renderIcon = (red) => {
        switch (red) {
            case "facebook": return faFacebookF;
            case "x": return faXTwitter;
            case "youtube": return faYoutube;
            case "instagram": return faInstagram;
            case "tiktok": return faTiktok;
            default: return faWikipediaW;
        }

    }
    return (
        <div className='FooterContain'>
            <div className='footerText'>
                <Anchor to=''>   <img src={logo} alt="logo" /></Anchor>
                <h2>
                    {contactos.razon_social}
                </h2>
                <div className='socials'>
                    {/* {JSON.stringify(contactos?.redes)} */}
                    {contactos?.redes?.map((item, key) => (
                        <div key={key}>
                            {/* {item.link != "" ?
                                <a target="t_blank" href={item.link} title={item.red} className='mx-2'  >
                                    <FontAwesomeIcon viewBox='0 0 369 369'
                                        icon={renderIcon(item.red)}
                                    />

                                </a>
                                : ""} */}
                            {item.link != "" &&
                                <Anchor to={contactos.facebook} target="_blank">
                                    <FontAwesomeIcon viewBox='0 0 369 369'
                                        icon={renderIcon(item.red)}
                                    />
                                </Anchor>
                            }
                        </div>
                    ))}
                </div>
            </div>
            <div className='footerText'>
                <h3>Contacto</h3>
                <Anchor to={`mailto:${contactos.email}`} target="_blank">{contactos.email}</Anchor>
                <Anchor to={`tel:${contactos.telefono}`} target="_blank">{contactos.telefono}</Anchor>
                <Anchor to={`https://www.google.com/maps?q=${encodeURIComponent(contactos.direccion)}`} target="_blank">{contactos.direccion}</Anchor>

            </div>
            <div className='footerText'>
                <h3>Productos</h3>
                <h3>Laptops</h3>

            </div>
            {/* <div className='footerText'>
                <h3>Acceso</h3>
                <Anchor to={`/dashboard`} className='btnAnch'>
                    <FontAwesomeIcon icon={faUser} /> Dashboard
                </Anchor>
            </div> */}
        </div>
    )
}
